import { useEffect } from 'react'

// footer: replaces Cancel / Save record (a read-only view: Close / Edit)
export default function Modal({ title, children, onClose, onSave, saving, error, footer }) {
  useEffect(() => {
    const handler = e => { if (e.key === 'Escape') onClose() }
    window.addEventListener('keydown', handler)
    return () => window.removeEventListener('keydown', handler)
  }, [onClose])

  return (
    <div style={styles.overlay} onClick={e => { if (e.target === e.currentTarget) onClose() }}>
      <div style={styles.modal} className="fade-up">
        <div style={styles.header}>
          <h3 style={styles.title}>{title}</h3>
          <button style={styles.closeBtn} onClick={onClose}>✕</button>
        </div>
        <div style={styles.body}>{children}</div>
        {error && <div className="err-box" style={{margin:'0 0 12px'}}>{error}</div>}
        <div style={styles.footer}>
          {footer || <>
          <button className="btn" onClick={onClose}>Cancel</button>
          <button className="btn btn-primary" onClick={onSave} disabled={saving}>
            {saving
              ? <><div className="spin" style={{width:12,height:12,borderTopColor:'var(--ink)'}} />Saving...</>
              : 'Save record'
            }
          </button>
          </>}
        </div>
      </div>
    </div>
  )
}

const styles = {
  overlay: {
    position: 'fixed', inset: 0,
    background: 'rgba(4,10,20,.8)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    zIndex: 500, padding: 20,
  },
  modal: {
    background: 'var(--ink2)',
    border: '0.5px solid var(--border2)',
    borderRadius: 14, width: '100%', maxWidth: 460,
    maxHeight: '88vh', overflow: 'hidden',
    display: 'flex', flexDirection: 'column',
    boxShadow: 'var(--shadow)',
  },
  header: {
    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
    padding: '18px 22px 14px',
    borderBottom: '0.5px solid var(--border)',
    flexShrink: 0,
  },
  title: {
    fontSize: 14, fontWeight: 500, color: 'var(--text)',
  },
  closeBtn: {
    background: 'transparent', border: 'none',
    color: 'var(--muted)', cursor: 'pointer',
    fontSize: 13, padding: '2px 6px', borderRadius: 4,
  },
  body: {
    padding: '18px 22px',
    overflowY: 'auto', flex: 1,
  },
  footer: {
    display: 'flex', gap: 8, justifyContent: 'flex-end',
    padding: '14px 22px',
    borderTop: '0.5px solid var(--border)',
    flexShrink: 0,
  },
}
